/**
 * Suggested positive / negative prompts for SD-based image providers
 * (Fooocus SDXL and ComfyUI SD 1.5).
 *
 * These are generic, model-agnostic quality boosters that work across
 * Stable Diffusion checkpoints. They are kept as plain English keyword
 * lists (NOT translated) because Stable Diffusion is trained on English
 * tags — the explanatory UI copy around them IS translated via i18n.
 *
 * Single source of truth lives in `constants/image/suggested_prompts.py`;
 * the actual values come from shared_constants.json (kept in sync by
 * `python scripts/generate_shared_constants.py`). This file just provides
 * typed named accessors. Do NOT hardcode the strings here.
 */

import sharedConstants from './shared_constants.json';

const misc = sharedConstants.constants.misc as unknown as {
  SUGGESTED_POSITIVE_PROMPT: string;
  SUGGESTED_NEGATIVE_PROMPT: string;
};

/** Quality-booster tags appended to the user's positive prompt. */
export const SUGGESTED_POSITIVE_PROMPT: string = misc.SUGGESTED_POSITIVE_PROMPT;

/** Common artefacts to exclude, used to fill an empty negative prompt. */
export const SUGGESTED_NEGATIVE_PROMPT: string = misc.SUGGESTED_NEGATIVE_PROMPT;
